var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "rows-list" },
    _vm._l(_vm.data, function(item, index) {
      return _c(
        "div",
        {
          key: `rows-list-${index}-${Math.random()}`,
          class: `rows-list__item rows-list__item__index-${index}`
        },
        [
          _c(
            "row-standard",
            _vm._g(
              {
                attrs: {
                  "access-type": _vm.accessType,
                  index: index,
                  value: item
                }
              },
              _vm.$listeners
            )
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }